/*
 * ---------------------------------------------------------------------------
 *
 * COPYRIGHT (c) 2023 IBS Software Canada Inc. All Rights Reserved.
 *
 * The copyright to the computer program(s) herein is the property of
 * IBS Software Canada Inc. The program(s) may be used and/or copied
 * only with the written permission from IBS Software Canada Inc.
 * or in accordance with the terms and conditions stipulated in the
 * agreement/contract under which the program(s) have been supplied.
 *
 * Date  : 2023-11-27
 *
 * ---------------------------------------------------------------------------
 */

import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import Navigation from './../../Navigation';
import * as actionsLogin from './../../../data/login/actions.js';
import TokenGuard from '../../TokenGuard';
import { httpStatus, STAFFID } from '../../../data/constants';
import { logout } from '../../../data/login/productionActions';

class OIDCMainLayout extends Component {
  constructor(props) {
    super(props);
    this.state = {
      staff: {}
    };
  }

  componentDidMount() {
    const staffId = sessionStorage.getItem(STAFFID);
    if (staffId) {
      this.props.getUserInformation(staffId).then((response) => {
        const responseData = response.data;
        if (responseData.status && responseData.status === httpStatus.UNAUTHORIZED) {
          logout('/login');
          // Preserve language preference
          const tempLng = localStorage.getItem('lng') || sessionStorage.getItem('lng');
          sessionStorage.clear();
          // Restore language preference
          if (tempLng) {
            localStorage.setItem('lng', tempLng);
            sessionStorage.setItem('lng', tempLng);
          }
        } else {
          this.setState({ staff: response.data });
        }
      });
    }
  }

  render() {
    return (
      <TokenGuard redirect={this.props.redirect}>
        <main>
          <Navigation
            user={this.props.user}
            logout={this.props.logout}
            staff={this.state.staff}
          />
          {this.props.children}
        </main>
      </TokenGuard>
    );
  }
}

OIDCMainLayout.propTypes = {
  children: PropTypes.node.isRequired,
  logout: PropTypes.func.isRequired,
  redirect: PropTypes.func.isRequired,
  user: PropTypes.object.isRequired,
  getUserInformation: PropTypes.func.isRequired
};

OIDCMainLayout.defaultProps = {
  children: {},
  logout: () => {},
  user: {},
  staff: {},
  getUserInformation: () => {}
};

const mapDispatchToProps = dispatch => ({
  logout: path => dispatch(actionsLogin.default.logout(path)),
  redirect: path => dispatch(actionsLogin.default.logout(path)),
  getUserInformation: staffId =>
    dispatch(actionsLogin.default.getUserInformation(staffId))
});

const mapStateToProps = state => ({ ...state.login });

export default connect(mapStateToProps, mapDispatchToProps)(OIDCMainLayout);
